<template>
  <div class="emb-product-detail">
    <template v-if="productDetails != null">
      <emb-page-title :heading="productDetails.Name" :image="bannerImage.Banner_Image"></emb-page-title>
      <div class="emb-productDetail-content white">
        <div class="product-detail section-gap">
          <v-container grid-list-xl py-0>
            <v-layout row wrap product-detail-row>
              <v-flex xs12 sm12 md6 lg6 xl6 text-center>
                <v-layout row wrap>
                  <v-flex xs2 sm2 md2 lg2 xl2 product-gallery>
                    <div
                      class="detail-image-gallery d-inline-block mb-6 mx-2"
                      v-for="(productItemImg,key) in productDetails.Product_Image_List"
                      :key="key"
                      @mouseover="togglePreviewImage(productItemImg.Product_Image_626_x_800px)"
                    >
                      <a href="javascript:void(0)">
                        <img
                          :src="productItemImg.Product_Image_626_x_800px"
                          width="71"
                          height="91"
                          alt="product image"
                        />
                      </a>
                    </div>
                  </v-flex>
                  <v-flex xs10 lg10 sm10 md10 xl10 product-detail-img>
                    <div class="product-detail-thumb">
                      <div class="image-wrapper emb-card">
                        <a href="javascript:void(0)">
                          <img
                            class="detailImg"
                            :src="selectedImage"
                            width="auto"
                            height="auto"
                            alt="product detail image"
                          />
                        </a>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6 xl5>
                <router-link to="/">{{MainContent.Back_To_Shop_Label}}</router-link>
                <h3>{{productDetails.Name}}</h3>
                <a
                  href="javascript:void(0)"
                  class="color-inherit text-underline mb-4 d-inline-block"
                  @click="showReviewPopup"
                >{{MainContent.Add_A_Review_Label}}</a>
                <emb-review-popup
                  ref="productReviewPopup"
                  :reviewdata="ReviewContent"
                  :ProductCode="productDetails.Product_Code"
                  :productName="productDetails.Name"
                  :details="productDetails.Details"
                ></emb-review-popup>
                <h4 class="accent--text">
                  <!-- <emb-currency-sign></emb-currency-sign> -->
                  <!-- {{$n(sellingPrice(productDetails)/ selectedCurrency.currencyRate,'currency',selectCurrency.selectedCurrency)}} -->
                  {{$n(sellingPrice(productDetails)/selectCurrency.CurrencyMultiplier,'currency',selectCurrency.selectedCurrency)}}
                </h4>
                <ul class="product-availablity list-unstyled pl-0 mb-4 mt-4">
                  <li>
                    <template v-if="productDetails.Is_Stock_Available === true">
                      <span class="font-weight-medium">{{MainContent.Availability_Label}}</span> :
                      <span class="font-weight-regular">{{MainContent.In_Stock_Label}}</span>
                    </template>
                    <template v-else>
                      <span class="font-weight-medium">{{MainContent.Availability_Label}}</span> :
                      <span class="font-weight-regular">{{MainContent.Out_of_Stock_Label}}</span>
                    </template>
                  </li>
                  <li>
                    <span class="font-weight-medium">{{MainContent.Product_Code_Label}}</span> :
                    <span class="font-weight-regular">{{productDetails.Product_Code}}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium">{{MainContent.Tags_Label}}</span>
                    <span>:</span>
                    <span
                      class="font-weight-regular"
                      v-for="(tag,key) in productDetails.Tag_List"
                      :key="key"
                    >{{tag.Tag_Name}}</span>
                  </li>
                </ul>
                <div v-html="productDetails.Description"></div>
                <!-- <p>{{productDetails.Description}}</p> -->

                <!-- <div class="bullet-points mb-4">
                  <ul class="features pl-13">
                    <li v-for="(Features,key) in productDetails.features" :key="key">{{Features}}</li>
                  </ul>
                </div>-->

                <!-- Product Size color -->
                <div class="select-group mb-4">
                  <v-layout wrap>
                    <v-flex
                      xs12
                      sm4
                      lg4
                      md4
                      lg3
                      xl3
                      pb-0
                      v-if="productDetails.Color && productDetails.Color != null  && productDetails.Color != ''"
                    >
                      <v-select
                        :items="selectedSubProducts"
                        :label="MainContent.Color_Label"
                        v-model="currentProduct"
                        required
                        @change="detailPage(currentProduct.More_details_page_link)"
                        item-text="Color"
                        return-object
                      ></v-select>
                    </v-flex>
                    <v-flex
                      xs12
                      sm4
                      lg4
                      md4
                      lg3
                      xl3
                      pb-0
                      v-if="productDetails.Size && productDetails.Size != null && productDetails.Size != '' && sizeSubProducts"
                    >
                      <v-select
                        :items="sizeSubProducts"
                        :label="MainContent.Size_Label"
                        v-model="currentProduct"
                        required
                        @change="detailPage(currentProduct.More_details_page_link)"
                        item-text="Size"
                        return-object
                      ></v-select>
                    </v-flex>
                    <!-- <v-flex xs12 sm4 lg4 md4 lg3 xl3 pb-0>
                      <v-select v-model="productDetails.quantity" :items="[1,2,3,4,5]"></v-select>
                    </v-flex>-->
                  </v-layout>
                </div>

                <!-- Product Size color End-->
                <v-flex>
                  <div class="mb-6">
                    <a
                      href="javascript:void(0)"
                      class="color-inherit text-underline"
                      @click="ToWishlist(productDetails.Product_Code,true,productDetails.Is_Sub_Type)"
                    >{{MainContent.Add_To_Wish_List_Label}}</a>
                  </div>
                </v-flex>
                <div class="mb-6 btn-wrap">
                  <!-- <v-btn
                    v-if="ifItemExistInCart(productDetails)"
                    class="accent cpx-0"
                    large
                    to="/cart"
                  >View Cart</v-btn>-->
                  <!-- <v-btn
                    v-else
                    class="accent d-inline-block cpx-0"
                    large
                    @click="addProductToCart(productDetails)"
                  >{{MainContent.Add_To_Cart_Button_Label}}</v-btn>-->
                  <v-btn
                    :disabled="!productDetails.Is_Stock_Available"
                    class="accent d-inline-block cpx-0"
                    large
                    @click="ToCart(productDetails.Product_Code,productDetails.Is_Sub_Type)"
                  >{{MainContent.Add_To_Cart_Button_Label}}</v-btn>
                  <v-btn
                    :disabled="!productDetails.Is_Stock_Available"
                    large
                    @click="BuyNow(productDetails.Product_Code,productDetails.Is_Sub_Type)"
                    class="white buyProduct cpx-0"
                  >{{MainContent.Buy_Now_Button_Label}}</v-btn>
                </div>
                <div>
                  <span>{{MainContent.Share_Now_Label}}</span>
                  <emb-social-share
                    class="mx-2"
                    @socialMediaPost="socialMediaShare"
                    :socialIcons="MainContent.Social_Media_List"
                  ></emb-social-share>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </div>

        <!-- <div class="related-product section-gap bg-grey">
          <v-container grid-list-xl class="py-0">
            <div class="sec-title">
              <h2 class="font-weight-medium">You Might Also Like</h2>
            </div>
            <div class="product-listing">
              <v-layout row wrap mb-4>
                <template v-for="(product, index) in products[title]">
                  <v-flex xs12 sm6 md6 lg3 xl3 mb3 text-center v-if="index <= 3" :key="index">
                    <div class="emb-card">
                      <div class="thumb-wrap">
                        <router-link :to="'/products/'+title+'/'+product.objectID">
                          <img :src="product.image" alt="related product" width="626" height="800" />
                        </router-link>
                        <div class="wishlist-icon">
                          <v-btn
                            v-if="ifItemExistInWishlist(product)"
                            @click="addItemToWishlist(product)"
                            icon
                          >
                            <v-icon class="black--text">favorite</v-icon>
                          </v-btn>
                          <v-btn v-else @click="addItemToWishlist(product)" icon>
                            <v-icon class="grey--text">favorite</v-icon>
                          </v-btn>
                        </div>
                        <div class="add-to-cart">
                          <v-btn
                            v-if="ifItemExistInCart(product)"
                            to="/cart"
                            class="primary"
                            small
                            icon
                          >
                            <v-icon medium>edit</v-icon>
                          </v-btn>
                          <v-btn
                            v-else
                            class="accent"
                            small
                            icon
                            @click="addProductToCart(product)"
                          >
                            <v-icon>shopping_cart</v-icon>
                          </v-btn>
                        </div>
                      </div>
                      <div class="emb-card-content px-6 py-4 white">
                        <h5 v-text="product.name"></h5>
                        <div class="emb-meta-info">
                          <div class="layout align-center justify-space-between pa-4">
                            <div class="inline-block">
                              <h6 class="accent--text font-weight-medium">
                                <emb-currency-sign></emb-currency-sign>
                                {{product.price}}
                              </h6>
                            </div>
                            <div class="inline-block">
                              <v-rating
                                :value="product.rating"
                                background-color="grey"
                                readonly
                                color="warning"
                              ></v-rating>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-flex>
                </template>
              </v-layout>
            </div>
            <div class="text-center">
              <v-btn :to="`/products/`+title" class="white">Show All</v-btn>
            </div>
          </v-container>
        </div>-->
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { deviceType } from "mobile-device-detect";
import gettingRestClientObject from "../../services/utils/cms-helper";

export default {
  computed: {
    ...mapGetters([
      "cart",
      "wishlist",
      "products",
      "selectCurrency",
      "selectedLocale",
      "subProducts",
    ]),
  },
  mounted() {
    var pageUrl = this.$route.query.page;
    // this.id = this.$route.params.id;
    // this.getParametre(this.title, this.id);
    this.cmsRequestFunctions = gettingRestClientObject();
    this.cmsRequestFunctions.getValidationMsgs();
    this.readShippingAddress();
    this.getPageData();
    this.getProductData(pageUrl);
  },
  watch: {
    selectedLocale: function () {
      var pageUrl = this.$route.query.page;
      this.selectedSubProducts = [];
      this.productDetails = {};
      this.getPageData();
      this.getProductData(pageUrl);
    },
    $route() {
      var pageUrl = this.$route.query.page;
      this.getProductData(pageUrl);
    },
  },
  data() {
    return {
      title: "",
      id: "",
      selectedImage: null,
      cmsRequestFunctions: null,
      MainContent: {},
      ReviewContent: {},
      productDetails: {},
      bannerImage: {},
      selectedSubProducts: [],
      sizeSubProducts: [],
      currentProduct: {},
      hasShippingAddress: false,
      selectedCurrency: localStorage.selectedCurrency
        ? localStorage.selectedCurrency
        : "AED",
      CurrencyMultiplier: localStorage.CurrencyMultiplier
        ? parseFloat(localStorage.CurrencyMultiplier)
        : parseFloat(1),
      deviceType: deviceType ? deviceType : "Desktop",
    };
  },
  methods: {
    ToWishlist(code, status, sub) {
      if (this.checkSignInOrNot()) {
        if (status) {
          var Items;
          if (sub) {
            Items = this.subProducts.find((item) => item.Product_Code === code);
          } else {
            Items = this.products.find((item) => item.Product_Code === code);
          }
          if (Items) {
            this.addItemToWishlist(Items);
          }
        }
      } else {
        this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M033"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
      }
    },
    ToCart(code, sub) {
      if (this.checkSignInOrNot()) {
        var Items;
        if (sub) {
          Items = this.subProducts.find((item) => item.Product_Code === code);
        } else {
          Items = this.products.find((item) => item.Product_Code === code);
        }
        if (Items) {
          this.addProductToCart(Items);
        }
      } else {
        this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M033"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
      }
    },
    BuyNow(code, sub) {
      if (this.checkSignInOrNot()) {
        var Items;
        if (sub) {
          Items = this.subProducts.find((item) => item.Product_Code === code);
        } else {
          Items = this.products.find((item) => item.Product_Code === code);
        }
        if (Items) {
          this.$store.dispatch("buyNow", {
            items: Items,
            hasAddress: this.hasShippingAddress,
          });
        }
      } else {
        this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M033"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
      }
    },
    sellingPrice(product) {
      if (product.Discount_Percentage) {
        return (
          product.Price - (product.Price * product.Discount_Percentage) / 100
        );
      } else {
        return product.Price;
      }
    },
    checkSignInOrNot() {
      var user = localStorage.getItem("embryo");
      if (user != null && user != undefined) {
        return true;
      } else {
        return false;
      }
    },
    /* for opening the popup **/
    showReviewPopup() {
      this.$refs.productReviewPopup.open();
    },
    /* for toggling image **/
    togglePreviewImage(image) {
      this.selectedImage = image;
    },
    /* for adding product in car	**/
    addProductToCart(item) {
      this.$snotify.success(
        this.cmsRequestFunctions.getValidationMsgByCode("M034"),
        {
          closeOnClick: false,
          pauseOnHover: false,
          timeout: 1000,
          showProgressBar: false,
        }
      );
      setTimeout(() => {
        this.$store.dispatch("addProductToCart", item);
      }, 500);
    },
    addItemToWishlist(product) {
      this.$snotify.success(
        this.cmsRequestFunctions.getValidationMsgByCode("M035"),
        {
          closeOnClick: false,
          pauseOnHover: false,
          timeout: 1000,
          showProgressBar: false,
        }
      );
      setTimeout(() => {
        this.$store.dispatch("addItemToWishlist", product);
      }, 500);
    },
    getPageData: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";
      var config = {
        pageType: "Template/",
        pageUrl: "19 Product Details/19 Product Details/19 Product Details.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;
          if (res.area_List) {
            var MainArea = self.cmsRequestFunctions.pluck(
              "Main_Content",
              res.area_List
            );
            self.MainContent = self.cmsRequestFunctions.getAllMapData(
              MainArea[0].component
            );
            var ReviewArea = self.cmsRequestFunctions.pluck(
              "Review_Section",
              res.area_List
            );
            self.ReviewContent = self.cmsRequestFunctions.getAllMapData(
              ReviewArea[0].component
            );
            var Banner = self.cmsRequestFunctions.pluck(
              "Banner_Section",
              res.area_List
            );
            self.bannerImage = self.cmsRequestFunctions.getAllMapData(
              Banner[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
    getProductData: function (key) {
      var self = this;
      var productUrl = key;
      if (productUrl && productUrl != "") {
        // productUrl = productUrl.split("-").join(" ");
        productUrl = productUrl.split("_")[0];
        var url = productUrl + ".ftl";
        var language = localStorage.Language ? localStorage.Language : "en";
        var config = {
          pageType: "Template/",
          pageUrl: url,
          lang: language,

          successCallback: function (response) {
            var res = response.data;
            if (res.area_List) {
              var MainArea = self.cmsRequestFunctions.pluck(
                "Main_Content",
                res.area_List
              );
              self.productDetails = self.cmsRequestFunctions.getAllMapData(
                MainArea[0].component
              );
              self.selectedImage =
                self.productDetails.Product_Image_626_x_800px;
              // self.selectedImage = self.productDetails.Product_Image_List[0];
              if (!self.productDetails.Is_Sub_Type) {
                self.selectedSubProducts = [];
                var currentProduct = self.products.find(function (el) {
                  return el.Product_Code === self.productDetails.Product_Code;
                });
                self.currentProduct = currentProduct;
                self.selectedSubProducts.push(self.currentProduct);
                if (self.productDetails.Sub_Types.length) {
                  self.productDetails.Sub_Types.forEach((element) => {
                    var subProduct = self.subProducts.find(function (el) {
                      return el.Product_Code === element.Product_Code;
                    });
                    if (subProduct) {
                      self.selectedSubProducts.push(subProduct);
                    }
                  });
                }
                self.setSizeList();
              } else {
                var currentSubProduct = self.subProducts.find(function (el) {
                  return el.Product_Code === self.productDetails.Product_Code;
                });
                if (currentSubProduct) {
                  self.currentProduct = currentSubProduct;
                  self.setSizeList();
                }
              }
            }
          },
          errorCallback: function (error) {
            console.log(error);
          },
        };
        self.cmsRequestFunctions.cmsRequest(config, language);
      }
    },
    detailPage(url) {
      if (url != "") {
        url = url.split("/Template/")[1];
        url = url.split(".").slice(0, -1).join(".");
        // url = "/product-details?page=" + url;
        this.getProductData(url);
      }
    },
    setSizeList() {
      var self = this;
      self.sizeSubProducts = self.selectedSubProducts.filter(function (el) {
        if (el && el.Color && self.currentProduct.Color) {
          return el.Color.trim() === self.currentProduct.Color.trim();
        }
      });
    },
    readShippingAddress: async function () {
      var self = this;
      var user = localStorage.getItem("embryo");
      if (user != null && user != undefined) {
        self.userData = JSON.parse(user);
        self.loginDetails = self.userData.user_data;
        var userName = self.loginDetails.loginId;
        self.email = self.loginDetails.email;
        var filterValue =
          "type='Shipping Address' AND keyword12='" + userName + "'";
        var allData = await self.cmsRequestFunctions.getDbDataTableValue(
          filterValue,
          "date1"
        );
        if (
          allData != undefined &&
          allData.data != undefined &&
          allData.status == 200
        ) {
          var shippingAddress = allData.data.data;
          if (shippingAddress) {
            self.hasShippingAddress = shippingAddress.length
              ? true
              : false || false;
          }
        } else {
          console.log("error:", allData);
        }
      }
    },
    socialMediaShare: async function (name) {
      var self = this;
      var userName = "Guest";
      var user = localStorage.getItem("embryo");
      if (user != null && user != undefined) {
        var userData = JSON.parse(user);
        userName = userData.user_data.loginId
          ? userData.user_data.loginId
          : "Guest";
      }
      try {
        let requestedDate = moment(String(new Date())).format(
          "YYYY-MM-DDThh:mm:ss"
        );
        let insertOrderData = {
          type: "Sharing on social media",
          date1: requestedDate,
          keyword1: name,
          keyword2: userName,
          text1: self.productDetails.Name,
          keyword4: self.productDetails.Product_Code,
          keyword5: self.deviceType,
        };
        var Success = await self.cmsRequestFunctions.cmsFormData(
          insertOrderData
        );
        self.isLoading = false;
        console.log(Success);
      } catch (error) {
        console.log(error);
        self.isLoading = false;
      }
    },
  },
};
</script>
